import { OverlayContainer } from '@angular/cdk/overlay';
import {
    Component,
    ElementRef,
    HostBinding,
    OnInit,
    Query,
    ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Credenciales } from '../../Interfaces/credenciales.interface';
import { AuthenticatorService } from 'src/app/Shared/Services/authenticator.service';
import { Title } from '@angular/platform-browser';
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { EncryptorService } from '../../Services/encryptor.service';
import { MatDialog } from '@angular/material/dialog';
import { RequestRestorePasswordComponent } from '../request-restore-password/request-restore-password.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogNuevoAspiranteComponent } from '../dialog-nuevo-aspirante/dialog-nuevo-aspirante.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { SolConfiguracionService } from '../../Modules/Aspirantes/Services/sol-configuracion.service';
import { SolConfiguracion } from '../../Modules/Aspirantes/Interfaces/sol-configuracion.interface';
import { SolConfiguracionPosgrado } from '../../Modules/Aspirantes/Interfaces/sol-configuracion-posgrado.interface';
import { RecaptchaComponent, ReCaptchaV3Service } from 'ng-recaptcha';
import { of, switchMap } from 'rxjs';
import { PingService } from '../../Services/ping.service';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
    credentialsForm: UntypedFormGroup = this.formBuilder.group({
        username: [{ value: '', disabled: true }, Validators.required],
        password: [{ value: '', disabled: true }, [Validators.required]],
    });

    error: boolean = false;
    showCaptcha = false;
    errorMessage: string;

    onLogin: boolean = false;

    darkMode: boolean = true;
    defaultColor: boolean = true;

    primary: string = '#014E82';
    maxWidth: string = '40%';
    padding: string = '0';

    logos: string = '/assets/img/logos.png';

    themeKey = 'THEME';
    colorThemeKey = 'THEME-COLOR';

    mobile = true;

    hide = true;

    img: string = environment.loginImage;

    @ViewChild('image') image: ElementRef;
    imageLoaded: boolean = false;

    @HostBinding('class') className = '';

    systemName: string = environment.systemName;
    shortSystemName: string = environment.shortSystemName;

    pageTitle: string = this.shortSystemName + ' :: Login';

    aspirantes: boolean = false;
    aspirantesPosgrado: boolean = false;

    production: boolean = environment.production;
    check: boolean = environment.check;

    periodo: string = '20253';

    @ViewChild('captcha') captcha: RecaptchaComponent;
    siteKey: string = environment.recaptcha.siteKey;

    constructor(
        private auth: AuthenticatorService,
        private router: Router,
        private overlay: OverlayContainer,
        private title: Title,
        private formBuilder: UntypedFormBuilder,
        private encryptorService: EncryptorService,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private snack: MatSnackBar,
        private ngxLoader: NgxUiLoaderService,
        private solConfiguracionService: SolConfiguracionService,
        private recaptchaV3Service: ReCaptchaV3Service,
        private pingService: PingService
    ) {}

    ngOnInit(): void {
        this.solConfiguracionService
            .getConfiguracion(this.periodo)
            .subscribe((conf: SolConfiguracion) => {
                const fecha_inicio: Date = new Date(conf.fecha_inicio);
                const fecha_fin: Date = new Date(conf.fecha_termino);
                const hoy: Date = new Date();
                hoy.setHours(0, 0, 0, 0);
                if (fecha_inicio <= hoy && hoy <= fecha_fin) {
                    this.aspirantes = true;
                }
            });
        this.solConfiguracionService
            .getConfiguracionPosgrado(this.periodo)
            .subscribe((conf: SolConfiguracionPosgrado) => {
                const fecha_inicio: Date = new Date(conf.fecha_inicio);
                const fecha_fin: Date = new Date(conf.fecha_termino);
                const hoy: Date = new Date();
                hoy.setHours(0, 0, 0, 0);
                if (fecha_inicio <= hoy && hoy <= fecha_fin) {
                    this.aspirantesPosgrado = true;
                }
            });
        this.ngxLoader.start();
        this.resize(window.innerWidth, screen.height);
        window.addEventListener('resize', () => {
            this.resize(window.innerWidth, screen.height);
        });
        // setTimeout(() => {

        // }, 100);
        this.checkTheme();
        this.setTitle();
        this.params();
        this.credentialsForm.controls.username.enable();
        this.credentialsForm.controls.password.enable();
    }

    ngAfterViewInit() {
        try {
            this.image.nativeElement.onload = () => {
                this.imageLoaded = true;
                this.ngxLoader.stop();
            };
        } catch (error) {
            this.imageLoaded = true;
            this.ngxLoader.stop();
        }
    }

    login(): void {
        if (!this.credentialsForm.valid) return;

        // Limpiar error al intentar ingresar otra vez
        this.error = false;
        // Bloquear botón
        this.onLogin = true;

        const formValues = this.credentialsForm.value;

        this.credentialsForm.controls.username.disable();
        this.credentialsForm.controls.password.disable();
        this.ngxLoader.start();
        this.hide = true;

        const encrypt: Credenciales = {
            username: formValues.username,
            password: this.encryptorService.encrypt(formValues.password),
        };

        this.recaptchaV3Service
            .execute('loginAction')
            .pipe(
                switchMap((token) => {
                    return this.pingService.validateRecapchaV3(token);
                })
            )
            .pipe(
                switchMap((recaptcha) => {
                    if (recaptcha) return this.auth.loginUser(encrypt);
                    else {
                        return of({ token: undefined });
                    }
                })
            )
            .subscribe(
                ({ token }) => {
                    if (token) {
                        this.auth.token = token;
                        this.auth.forceChangePassword = encrypt.password;
                        const lastPage = this.auth.lastPage;
                        const payload = this.auth.userPage;

                        this.ngxLoader.stop();

                        if (lastPage) {
                            this.auth.clearLastPage();
                            location.replace(lastPage);
                        } else {
                            this.router.navigate([payload]);
                        }
                    } else {
                        this.ngxLoader.stop();
                        this.auth.clearForceChangePassword();
                        // Habilitar botón

                        this.errorMessage =
                            'Tráfico inusual procedente de tu red de computadoras';
                        this.error = true;
                        this.showCaptcha = true;
                    }
                },
                (err: HttpErrorResponse) => {
                    switch (err.status) {
                        case 401:
                        case 422:
                        case 404:
                            // Unauthorized

                            // Limpiar contraseña
                            this.credentialsForm.controls.username.setValue('');
                            this.credentialsForm.controls.password.setValue('');

                            this.errorMessage =
                                'Datos incorrectos. Intente otra vez';

                            break;
                        case 403:
                            this.errorMessage = err.error.error.message;
                            break;
                        default:
                            this.errorMessage =
                                'Ocurrió un error. Intente de nuevo más tarde';

                            break;
                    }

                    this.auth.clearForceChangePassword();
                    // Habilitar botón
                    this.onLogin = false;
                    this.credentialsForm.controls.username.enable();
                    this.credentialsForm.controls.password.enable();
                    this.ngxLoader.stop();
                    // Mostrar error
                    this.error = true;
                    this.showCaptcha = false;
                }
            );
    }

    resize(width: number, height: number) {
        if (width <= 576) {
            this.maxWidth = '100%';
            this.padding = '30px';
        } else if (width <= 800) {
            this.maxWidth = '60%';
            this.padding = '20px';
        } else {
            this.maxWidth = '33%';
            this.padding = '10px';
        }

        this.mobile = true;//= this.check ||  width <= 500 && height <= 850;
    }

    setTheme(darkMode: boolean) {
        const darkClassName = 'darkMode';
        const darkDevClassName = 'darkMode-dev';
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';
        const lightGreenClassName = 'lightMode-check';

        this.className = this.production
            ? darkMode
                ? darkClassName
                : lightClassName
            : this.check
            ? lightGreenClassName
            : darkDevClassName;

        localStorage.setItem(
            this.themeKey,
            this.encryptorService.aesEncrypt(this.className)
        );

        this.overlay
            .getContainerElement()
            .classList.remove(
                darkClassName,
                lightblueClassName,
                lightRedClassName,
                darkDevClassName
            );

        if (!this.production) {
            this.overlay.getContainerElement().classList.add(darkDevClassName);
            this.logos = '/assets/img/logos_white.png';
        } else if (darkMode) {
            this.overlay.getContainerElement().classList.add(darkClassName);
            this.logos = '/assets/img/logos_white.png';
        } else {
            this.checkColorLightTheme();
            this.logos = '/assets/img/logos.png';
        }
    }

    setColorLightTheme(defaultColor: boolean) {
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';

        const redClassName = 'red';
        const blueClassName = 'blue';

        this.className = defaultColor ? lightblueClassName : lightRedClassName;

        const className = defaultColor ? blueClassName : redClassName;

        localStorage.setItem(
            this.colorThemeKey,
            this.encryptorService.aesEncrypt(className)
        );

        this.overlay
            .getContainerElement()
            .classList.remove(lightblueClassName, lightRedClassName);

        if (defaultColor) {
            this.overlay
                .getContainerElement()
                .classList.add(lightblueClassName);
        } else {
            this.overlay.getContainerElement().classList.add(lightRedClassName);
        }
    }

    checkTheme() {
        const classStoraged = localStorage.getItem(this.themeKey);
        const className = classStoraged
            ? this.encryptorService.aesDecrypt(classStoraged)
            : '';
        const darkMode = className == 'darkMode';

        this.setTheme(darkMode);

        this.darkMode = darkMode;
    }

    checkColorLightTheme() {
        const redClassName = 'red';

        const classStoraged = localStorage.getItem(this.colorThemeKey);
        const className = classStoraged
            ? this.encryptorService.aesDecrypt(classStoraged)
            : '';
        const defaultColor = className != redClassName;

        this.setColorLightTheme(defaultColor);

        this.defaultColor = defaultColor;
    }

    setTitle() {
        this.title.setTitle(this.pageTitle);
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(RequestRestorePasswordComponent, {
            width: '500px',
            data: this.darkMode,
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    openDialogNuevoAspirante(posgrado?: boolean): void {
        const dialogRef = this.dialog.open(DialogNuevoAspiranteComponent, {
            width: '90%',
            data: {
                darkMode: this.darkMode,
                posgrado,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    params() {
        const invalidToken: boolean = this.auth.invalidToken ?? false;

        if (invalidToken) {
            const expiredToken: boolean = this.auth.expiredToken ?? false;
            const errorToken: boolean = this.auth.backendErrorToken ?? false;
            const closingSemester: boolean = this.auth.closingSemester ?? false;

            const message = expiredToken
                ? 'Ha Caducado'
                : errorToken
                ? 'No pudo ser Validada'
                : closingSemester
                ? 'No Puede Continuar por Cierre de Semestre'
                : 'No es Valida';

            this.snack.open(`La Sesión ${message}`, '🤖', {
                duration: 8000,
                panelClass: ['snack'],
                horizontalPosition: 'right',
                verticalPosition: 'top',
            });
        }

        this.auth.clearInvalidToken();
    }

    resolved(event: any) {
        if (event) {
            this.pingService.token_captcha2 = event;
            this.onLogin = false;
            this.credentialsForm.controls.username.enable();
            this.credentialsForm.controls.password.enable();
            this.showCaptcha = false;
            this.error = false;
        }
    }
}
